export const applyEditsToRawData = (categoriaData, editedMonths) => {
  if (!editedMonths || Object.keys(editedMonths).length === 0) return categoriaData;

  const stripMonth = (entries, year, month) =>
    (entries || []).filter(d => !(d.year === year && d.month === month));

  let { planoData, realizadoData, estoquePecasData, ...rest } = categoriaData;

  Object.entries(editedMonths).forEach(([key, edited]) => {
    const [year, month] = key.split('-').map(Number);

    const num = (v) => (v != null ? Number(Number(v).toFixed(2)) : null);

    if (edited.editedBase) {
      realizadoData = stripMonth(realizadoData, year, month);

      planoData = stripMonth(planoData, year, month).concat([{
        year, month,
        grossRevenue: num(edited.grossRevenue),
        unitsSold: Math.floor(edited.unitsSold),
        originalPrice: num(edited.originalPrice),
        unitCost: num(edited.unitCost),
        salePrice: num(edited.salePrice),
        markdownPercent: num(edited.markdownPercent),
        initialMarkup: num(edited.initialMarkup),
        finalMarkup: num(edited.finalMarkup),
        grossProfit: num(edited.grossProfit),
      }]);
    }

    const originalEstoque = (estoquePecasData || []).find(
      d => d.year === year && d.month === month
    ) || {};

    estoquePecasData = stripMonth(estoquePecasData, year, month).concat([{
      ...originalEstoque,
      year, month,
      initialInventoryUnits: edited.initialInventoryUnits,
      endingInventoryUnits: edited.endingInventoryUnits,
      inboundInventoryUnits: edited.inboundInventoryUnits,
      openToBuyUnits: edited.openToBuyUnits,
      grossOpenToBuyUnits: edited.grossOpenToBuyUnits,
      minimumInventoryUnits: edited.minimumInventoryUnits,
      actualInventoryCoverage: edited.actualInventoryCoverage,
      plannedInventoryCoverage: edited.plannedInventoryCoverage,
    }]);
  });

  return { planoData, realizadoData, estoquePecasData, ...rest };
};